import angular from 'angular';
import ngSanitize from 'angular-sanitize';

// Component
import simpleFieldInstanceComponent from './simpleFieldInstance.component';
import componentNameForFieldType from '../simpleFields';

// Dependencies
import simpleFieldsModule from '../simpleFields/module';
import '../../../../../lib/service';
//import serviceModule from '../../service/module';
//import fieldsModule from '../fields/module';

let module = angular.module('staff.dashboardScreen.simpleFieldInstance', [
  simpleFieldsModule.name,
  ngSanitize,]);

module.component('simpleFieldInstance', simpleFieldInstanceComponent);

export default module;
